module.exports = __webpack_public_path__ + "img/webchat.2a4c7a32.svg";